export default {"src":"/_next/static/media/left-arrow-dark.6974fcd1.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};